import * as tslib_1 from "tslib";
import { Model } from '@app/models/model';
var WaterStatus = /** @class */ (function (_super) {
    tslib_1.__extends(WaterStatus, _super);
    function WaterStatus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WaterStatus;
}(Model));
export { WaterStatus };
var LeakStatus = /** @class */ (function (_super) {
    tslib_1.__extends(LeakStatus, _super);
    function LeakStatus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LeakStatus;
}(Model));
export { LeakStatus };
var ActiveLeak = /** @class */ (function (_super) {
    tslib_1.__extends(ActiveLeak, _super);
    function ActiveLeak() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ActiveLeak;
}(Model));
export { ActiveLeak };
